import api from './api';

const BASE_URL = '/work-orders';

export const workOrdersService = {
  // Get all work orders with filters
  getWorkOrders: async (params = {}) => {
    const response = await api.get(`${BASE_URL}/jobs`, { params });
    return response.data;
  },

  // Get single work order
  getWorkOrder: async (id) => {
    const response = await api.get(`${BASE_URL}/jobs/${id}`);
    return response.data;
  },

  // Create new work order
  createWorkOrder: async (data) => {
    const response = await api.post(`${BASE_URL}/jobs`, data);
    return response.data;
  },

  // Update work order
  updateWorkOrder: async (id, data) => {
    const response = await api.put(`${BASE_URL}/jobs/${id}`, data);
    return response.data;
  },

  // Update work order status
  updateStatus: async (id, status, notes = null) => {
    const response = await api.patch(`${BASE_URL}/jobs/${id}/status`, { status, notes });
    return response.data;
  },

  // Delete work order
  deleteWorkOrder: async (id) => {
    const response = await api.delete(`${BASE_URL}/jobs/${id}`);
    return response.data;
  },

  // Duplicate work order
  duplicateWorkOrder: async (id) => {
    const response = await api.post(`${BASE_URL}/jobs/${id}/duplicate`);
    return response.data;
  },

  // Get work order history
  getHistory: async (id) => {
    const response = await api.get(`${BASE_URL}/jobs/${id}/history`);
    return response.data;
  },

  // Download PDF
  downloadPdf: async (id, workOrderNumber) => {
    const response = await api.get(`${BASE_URL}/jobs/${id}/pdf`, {
      responseType: 'blob'
    });

    // Create download link
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${workOrderNumber || 'work-order'}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // Get dashboard stats
  getStats: async () => {
    const response = await api.get(`${BASE_URL}/stats`);
    return response.data;
  },

  // Get print queue
  getPrintQueue: async () => {
    const response = await api.get(`${BASE_URL}/print-queue`);
    return response.data;
  },

  // Get available statuses
  getStatuses: async () => {
    const response = await api.get(`${BASE_URL}/statuses`);
    return response.data;
  },

  // Get users for assignment
  getUsers: async () => {
    const response = await api.get(`${BASE_URL}/users`);
    return response.data;
  }
};

export default workOrdersService;
